module.exports = __webpack_public_path__ + "static/media/tournament-group.c4f30ef1.png";